module.exports = __webpack_public_path__ + "img/pc_header_bg.20e4ae0.webp";